import MoneyFormatter from './formatter';
import MoneyCurrency from './currency';

export default class Money {
  constructor(fractional, currency) {
    if (typeof(fractional) !== 'number') throw new TypeError('fractional has to be a Number');

    this.fractional = fractional;
    this.currency = new MoneyCurrency(currency);
  }

  format(rules = {}) {
    return new MoneyFormatter(this).format(rules);
  }

  negative() {
    return this.fractional < 0;
  }

  positive() {
    return this.fractional > 0;
  }
}
